// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "613b2f4a3ab85e1e4f59cf95f267d02e483c9743/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};